import Model from "../classes/Model";
import Api from "../classes/api/DirectionSalaryScheme";
import ValidationError from "../classes/ValidationError";

export default class DirectionSalaryScheme extends Model {

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get id() {
        return this._id;
    }

    get counts() {
        return this._counts;
    }
    set counts(value) {
        this._counts = value;
    }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }



    toRequest() {
        return {
            id: this.id,
            name: this.name,
            counts: this.counts,
        };
    }

    static toResponse(data) {
        return {
            id: data.id,
            name: data.name,
            counts: data.counts,
        };
    }

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = []) {
        return Api.getList(page, perPage, sort, extraFields).then((response) => {
            let data = [];
            for (let trainer of response.data) {
                data.push(new this(this.toResponse(trainer)));
            }
            return {data, headers: response.headers};
        });
    }

    static get(id) {
        return Api.get(id).then(({data}) => {
            let fields = this.toResponse(data);
            fields.id = Number(id);
            return new this(fields);
        });
    }


    add() {
        let request = this.toRequest();
        return Api.add(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            request.id = Number(data.id);
            return new DirectionSalaryScheme(request);
        });
    }

    update() {
        if (!this.id) {
            throw new Error('id not set');
        }
        let request = this.toRequest();
        return Api.update(request).then(({data}) => {
            if (data.success === false) {
                throw new ValidationError(data.errors);
            }
            return true;
        })
    }


    remove() {
        return Api.remove({id: this.id}).then(({data}) => {
            return data.success;
        });
    }

}